<h1>{{ 'referentiels.list.cedProperties.caption'| transloco }}</h1>

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterCed()"></p-button>
}

<p-table
  #cedTable
  [value]="cedResult"
  selectionMode="single"
  [(selection)]="selectedCed"
  [resizableColumns]="true"
  columnResizeMode="expand"
  dataKey="id"
  editMode="row"
  [rows]="25"
  [rowsPerPageOptions]="[10, 25, 50]"
  styleClass="p-datatable-striped"
  [loading]="loading"
  [paginator]="true"
  [totalRecords]="totalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  [tableStyle]="{ 'min-width': '50rem', 'table-layout': 'fixed' }"
>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="code" style="width: 5%">{{ 'referentiels.list.cedProperties.code.header'| transloco }} <p-sortIcon field="code" /></th>
      <th pResizableColumn pSortableColumn="danger" style="width: 3%">{{ 'referentiels.list.cedProperties.danger.header'| transloco }} <p-sortIcon field="danger" /></th>
      <th pResizableColumn pSortableColumn="libelle" style="width: 20%">{{ 'referentiels.list.cedProperties.libelle.header'| transloco }} <p-sortIcon field="libelle" /></th>
      <th pResizableColumn pSortableColumn="niveauCED" style="width: 5%">{{ 'referentiels.list.cedProperties.niveauCed.header'| transloco }} <p-sortIcon field="niveauCED" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="code" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par code" [showMenu]="false" [showClearButton]="false" />
      </th>
      <th>
        <p-columnFilter matchMode="equals" type="boolean" field="danger" placeholder="--Filtre--" ariaLabel="Filtre par danger" [showMenu]="false" [showClearButton]="false" />
      </th>
      <th>
        <p-columnFilter type="text" field="libelle" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par libelle" [showMenu]="false" [showClearButton]="true" />
      </th>
      <th>
        <p-columnFilter field="niveauCED" matchMode="equals" [showMenu]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-dropdown [ngModel]="value" [options]="niveauCedOptions" [filter]="true" filterBy="label" [showClear]="true" appendTo="body" (onChange)="filter($event.value)" placeholder="--Filtre--"> </p-dropdown>
            <!-- <ng-template let-option pTemplate="item">
                            <span [class]="option.value">{{option.label}}</span>
                        </ng-template> -->
          </ng-template>
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="cedForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
        <td *ngIf="userHasReadWritePermission">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierCed(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsCed(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsCed(rowData, ri)"></button>
          </div>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="code" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.code }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td class="text-center align-middle">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-checkbox formControlName="danger" binary="true" class="centered-checkbox"></p-checkbox>
            </ng-template>
            <ng-template pTemplate="output">
              <i class="pi" [ngClass]="{ 'text-green-700 pi-check-circle': rowData.danger, 'text-red-500 pi-times-circle': !rowData.danger }" style="display: flex; justify-content: center; align-items: center"> </i>
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="libelle" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.libelle }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown formControlName="niveauCED" [options]="niveauCedOptions" optionLabel="label" optionValue="value" placeholder="rowData.niveauCED" appendTo="body"> </p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.niveauCED }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>
</p-table>
<p-toast />
